import { pi, sqrt, tau } from "../math.js";
export default {
  draw: function draw(context, size) {
    var r = sqrt(size / pi);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, tau);
  }
};